import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { ListItem } from '®app/shared/reading-list';
import { idWithoutDotHtml } from '®shared/router';

import { ItemResolverStoreService } from '../resolver-store';

@Injectable()
export class ItemResolver implements Resolve<ListItem> {
  constructor(private itemResolverStoreService: ItemResolverStoreService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<ListItem> {
    const itemId = idWithoutDotHtml(route.params.itemId);
    if (route.data.isDraft) {
      return this.itemResolverStoreService.getDraftItem(itemId);
    } else {
      return this.itemResolverStoreService.getPublishedItem(itemId);
    }
  }
}
